export const MIN_TRACK_DURATION_MS = 50;
export const TIMELINE_MIN_HEIGHT = 140;
export const TIMELINE_MAX_HEIGHT = 420;
export const TIMELINE_DEFAULT_HEIGHT = 140;

export const FILE_SIZE_REQUEST: RequestInit = { method: 'HEAD' };
export const FILE_SIZE_CACHE = new Map<string, Promise<number | null>>();
export const MAX_CONCURRENT_FILE_SIZE_REQUESTS = 6;
export const MEDIA_IMAGE_ELEMENT_TYPES = ['image', 'svg', 'gif'];

export const FORMAT_PREVIEW_IMAGES = [
	'https://bay.cdn.bkat.io/smc/listingoverlays/portrait_image.png',
	'https://bay.cdn.bkat.io/smc/listingoverlays/story_image.png',
	'https://bay.cdn.bkat.io/smc/listingoverlays/landscape_image.png',
	'https://bay.cdn.bkat.io/smc/listingoverlays/square_image.png',
];
